module.exports = __webpack_public_path__ + "media/images/covid/icons/cashless-73ba7f03563ec82b788cd262607cb916.png";